// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleCryptoColosseum as _skaleCryptoColosseum } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleCryptoColosseum chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1032942172
 * Chain Name: SKALE | Crypto Colosseum
 * Default Block Explorer: https://haunting-devoted-deneb.explorer.mainnet.skalenodes.com
 * Default RPC URL: https://mainnet.skalenodes.com/v1/haunting-devoted-deneb
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleCryptoColosseum } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleCryptoColosseum,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleCryptoColosseum = createCommon({
	..._skaleCryptoColosseum,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
